export const APP_STORE_LINK = "https://apps.apple.com/pl/app/outlet-park-szczecin/id6444443951?l=pl";
export const GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=pl.sofine.outletPark&hl=pl"; 
export const APP_URL = 'outletPark://';
